import { ButtonsModel } from "./button.model";
import { TableInfoHeader } from "./tableinfoheader.model";

export class TableInfo {
    public label: string;
    public buttons: ButtonsModel[];
    public headers: { [key: string]: TableInfoHeader};
    public items: unknown[];
    public itemsPerPage: number;
    public optionalButton: ButtonsModel;
    public disableItems: boolean[];

    constructor(
        headers: { [key: string]: TableInfoHeader},
        items: unknown[],
        itemsPerPage?: number,
        buttons?: ButtonsModel[],
        disableItems?: boolean[],
        optionalButton?: ButtonsModel,
        label?: string) {
        this.headers = headers;
        this.items = items;
        if (itemsPerPage != null) {
            this.itemsPerPage = itemsPerPage;
        }
        if (buttons != null) {
            this.buttons = buttons;
        }
        if (optionalButton != null) {
            this.optionalButton = optionalButton;
        }
        if (label) {
            this.label = label;
        }
        if (disableItems) {
            this.disableItems = disableItems;
        }
    }
}